import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VacanciesCategoryService implements OnInit {

  showPopup: boolean = false;

  constructor(private http: HttpClient) {
  }

  onComplaintsClick() {
    this.showPopup = true;
  }

  ngOnInit(): void {
    this.onComplaintsClick();
  }

  complaintIsActive: boolean = false;

  // getDepartmentsWithVacancyCount() {
  //   return this.http.get(`/v1/vacancies/count-active-vacancies-per-department`);
  // }
  getDepartmentsWithVacancyCount() {
    return this.http.get(`${environment.apiUrl}/v1/vacancies/count-active-vacancies-per-department`)
      .pipe(
        catchError(error => {
          console.error('Error fetching departments:', error);
          return throwError(error);
        })
      );
  }



  // getDepartmentsWithVacancyCount() {
  //   return this.http.get(`http://careers.telone.co.zw:1930/TeloneEJobPortal/api/v1/vacancies/count-active-vacancies-per-department`);
  // }
  // getDepartmentsWithVacancyCount() {
  //   return this.http.get(`/api/v1/vacancies/count-active-vacancies-per-department`);
  // }
  //${environment.apiUrl}
}
